import { DateTime } from "luxon";
import { useMemo } from "react";

import { LISPatient } from "pwapi";

const useUserInformationInputs = (
  idPrefix: string = "user",
  isRelationship: boolean = false,
  parentResource?: string,
  namePrefix?: string
) => {
  const getInputName = (name: string) =>
    `${parentResource ? `${parentResource}.` : ""}${
      namePrefix ? `${namePrefix}_` : ""
    }${name}`;
  const inputs = useMemo(() => {
    return {
      lastName: {
        name: getInputName("last_name"),
        id: `${idPrefix}__last_name`,
        label: `${isRelationship ? "Sub " : ""}Last Name`,
      },
      firstName: {
        name: getInputName("first_name"),
        id: `${idPrefix}__first_name`,
        label: `${isRelationship ? "Sub " : ""}First Name`,
      },
      middleInitial: {
        name: getInputName("middle_initial"),
        id: `${idPrefix}__middle_initial`,
        label: `${isRelationship ? "Sub " : ""}M.I.`,
        maxLength: 2,
      },
      dateOfBirth: {
        name: getInputName("date_of_birth"),
        id: `${idPrefix}__date_of_birth`,
        label: `${isRelationship ? "Sub " : ""}D.O.B`,
        type: "date",
        max: DateTime.now().toISODate(), // Prevent future dates
      },
      sex: {
        name: getInputName("sex"),
        id: `${idPrefix}__sex`,
        label: `${isRelationship ? "Sub " : ""}Sex`,
        type: "select",
        options: Object.values(LISPatient.sex).map((val) => ({
          value: val,
          label: val,
        })),
        defaultOptionLabel: "Select...",
      },
      ssn: {
        name: getInputName("ssn"),
        id: `${idPrefix}__ssn`,
        label: `${isRelationship ? "Sub " : ""}SSN`,
        maxLength: 11,
        minLength: 11,
      },
      mrn: {
        name: getInputName("medical_record_number"),
        id: `${idPrefix}__medical_record_number`,
        label: "Medical Record Number",
      },
      externalPatientId: {
        name: getInputName("external_patient_id"),
        id: `${idPrefix}__external_patient_id`,
        label: "External Patient ID",
      },
      employer: {
        name: getInputName("employer"),
        id: `${idPrefix}__employer`,
        label: `${isRelationship ? "Sub " : ""} Employer`,
      },
      subRelationship: {
        id: `${idPrefix}__relationship_to_patient`,
        name: `${
          parentResource ? `${parentResource}.` : ""
        }relationship_to_patient`,
        label: `${isRelationship ? "Sub" : ""}Relationship`,
        type: "select",
        defaultOptionLabel: "Select...",
        options: ["SELF", "SPOUSE", "PARENT", "OTHER"].map((option) => ({
          value: option,
          label: option,
        })),
      },
    };
  }, [parentResource, namePrefix, isRelationship, idPrefix]);

  return inputs;
};

export default useUserInformationInputs;
